import React from 'react';
import { Typography, Divider } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import GroupHeader from './GroupHeader';
import SettingForm from './forms/SettingForm';
import { useFormContext } from '../context/FormContext';
import { useFields } from '../hooks/useFields';
import { useSettings } from '../hooks/useSettings';
import { useFormOperations } from '@components/Home/Config-Beta/Modes/ControlModesTemplateCreateEditModal/hooks';
import GroupFields from './GroupFields';

const GroupedFieldsGrid: React.FC = () => {
  const { state } = useFormContext();
  const { groupedFields } = state;

  const { showAddField, isEditMode, editingField } = useFields();

  const { showAddSetting, isSettingEditMode, editingSetting } = useSettings();

  const { hasAttemptedSubmit, fieldErrors, handleChange, handleSelectChange } =
    useFormOperations();

  return (
    <Grid2 container spacing={2} size={12}>
      {groupedFields.length > 0 ? (
        groupedFields.map((group, groupIndex) => (
          <React.Fragment key={`group-${groupIndex}-${group.controllerField}`}>
            {groupIndex > 0 && (
              <Grid2 size={12} sx={{ my: 2 }}>
                <Divider sx={{ bgcolor: 'white', opacity: 0.3 }} />
              </Grid2>
            )}

            <GroupHeader group={group} groupIndex={groupIndex} />

            {/* Display setting validation error if exists */}
            {hasAttemptedSubmit &&
              fieldErrors[`setting_${group.controllerField}`] && (
                <Grid2 size={12}>
                  <Typography variant='body2' color='error'>
                    {fieldErrors[`setting_${group.controllerField}`]}
                  </Typography>
                </Grid2>
              )}

            {/* Edit Setting Form - render directly below the setting name when in edit mode */}
            {showAddSetting &&
              isSettingEditMode &&
              editingSetting &&
              editingSetting.controllerField === group.controllerField && (
                <SettingForm
                  isEditMode={true}
                  editingSettingLabel={editingSetting.uiLabel}
                />
              )}

            {/* Fields in this group */}
            <GroupFields
              fields={group.fields}
              hasAttemptedSubmit={hasAttemptedSubmit}
              fieldErrors={fieldErrors}
              handleChange={handleChange}
              handleSelectChange={handleSelectChange}
              showAddField={showAddField}
              isEditMode={isEditMode}
              editingField={editingField}
            />
          </React.Fragment>
        ))
      ) : (
        <Grid2 size={12}>
          <Typography align='center'>No fields available</Typography>
        </Grid2>
      )}
    </Grid2>
  );
};

export default GroupedFieldsGrid;
